import { httpMethods } from 'enums';
import { Http } from 'library';
import api from 'api/client';

import * as Endpoints from 'constants/endpoints.constant';

class GiftHttp {
  async createGift(data: any) {
    return await Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.CREATE_GIFT}`)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }
  async sentGiftsList(customerId: any, partnerId: any, page: any) {
    return await Http.setMethod(httpMethods.get)
      .setUrl(
        `${Endpoints.SENT_GIFT_LIST}?customerId=${customerId}&partnerId=${partnerId}&pageSize=10&page=${page}`
      )
      .setToken(api.getToken())
      .request();
  }
  async receievedGiftsList(mobileNo: any, partnerId: any, page: any) {
    return await Http.setMethod(httpMethods.get)
      .setUrl(
        `${Endpoints.SENT_GIFT_LIST}?receiverMobileNo=${mobileNo}&partnerId=${partnerId}&pageSize=10&page=${page}`
      )
      .setToken(api.getToken())
      .request();
  }
  async rejectGift(data: any) {
    return await Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.REJECT_GIFT}`)
      .setData(data)

      .setToken(api.getToken())
      .request();
  }
  async acceptGift(data: any) {
    return await Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.ACCEPT_GIFT}`)
      .setData(data)

      .setToken(api.getToken())
      .request();
  }
}

export default new GiftHttp();
